import restProvider from 'ra-data-simple-rest'
import { fetchUtils } from 'react-admin'
import { auth0, getApiUrl } from '../auth/client'
import fakeTreeDataProvider from './fakeTreeDataProvider'

const httpClient = async (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' })
  }
  options.headers.set('Authorization', `Bearer ${await auth0.getTokenSilently()}`)
  return fetchUtils.fetchJson(url, options)
}

const dataProvider = async (type, resource, params) => {
  const baseApiUrl = await getApiUrl()
  if (!baseApiUrl) {
    return fakeTreeDataProvider(type, resource, params)
  }
  const apiUrl = `${baseApiUrl}/api`
  switch (type) {
    case 'GET_TREE_ROOT_NODES':
      return httpClient(`${apiUrl}/${resource}?parentId=root`).then((response) => ({ data: response.json }))
    case 'GET_TREE_CHILDREN_NODES':
      return httpClient(`${apiUrl}/${resource}?parentId=${params.id}`).then((response) => ({ data: response.json }))
    default:
      const baseProvider = restProvider(apiUrl, httpClient)
      return baseProvider(type, resource, params)
  }
}

export default dataProvider
